





















































































































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import ListViewItem from "list-view/src/listviewitem";
import NewsModel from "@views/a-model/news-model";
import DefaultModel from "@views/a-model/default-model";
import ControlValidatorGroupComponent from "../components/control-validator-group.vue";
import iMarket from "../a-model/interfaces/iMarket";
import iMobileDeviceUser from "../a-model/interfaces/iMobileDeviceUser";
import EnumMobileRoles from "../../dataSource/api/RunPay/Admin/IServices/Enums/EnumMobileRoles";
import DeviceModel from "../a-model/devce-model";

@Component({
  name: "devices",
  components: {}
})
export default class DevicesComponent extends Vue {
  currentRolleId: String = null;
  currentUserId: String = null;
  roles: ListViewItem<DefaultModel>[] = [];
  userRoles: ListViewItem<DefaultModel>[] = [];
  userId = "";
  userName = "";

  terminaleCode = "";

  pageSize = 10;
  currentPage = 1;
  totalItems = 5;

  devices: ListViewItem<DeviceModel>[] = [];
  user: iMobileDeviceUser = null;

  modalWindowShow = false;

  search = "";
  Items: iMarket[] = [];
  innerItems: iMarket[] = [];
  // newMarket:iMarket = null;

  created() {
    document.title = this.$route.meta.title;
    this.getUser(this.$route.params.userId);
    this.getRolesDD();
  }
  /*фильтр по точкам*/
  onSearch() {
    this.getItems({ Skip: 0, Take: this.pageSize });
  }
  /*возвращаемся на страницу списка пользователей */
  goMobileDeviceUsers() {
    this.$router.push({ path: "/mobile-users" });
  }

  /*получаем информацию о пользователе */
  getUser(userId: string) {
    this.$api.UserMobileService.GetSingleUserEvent.once(response => {
      if (!response) {
        return;
      }
      this.user = {
        id: response.Value.UserId.toString(),
        name: response.Value.Name == null ? "" : response.Value.Name.toString(),
        email:
          response.Value.Email == null ? "" : response.Value.Email.toString(),
        dateCreate: new Date(),
        role: response.Value.Roles
      };

      this.getItems({ Take: this.pageSize, Skip: 0 });
    });
    this.$api.UserMobileService.GetSingleUser(parseInt(userId));
  }

  getItems({ Skip, Take }: { Skip: number; Take: number }) {
    this.innerItems = [];
    this.$api.UserMobileService.GetPaginatedUserTerminalsEvent.once(
      response => {
        if (!response.IsSuccess) {
          return;
        }
        this.totalItems = response.Value.Count;
        this.innerItems = response.Value.Items.map(item => ({
          id: item.Id.toString(),
          name: item.Name.toString(),
          address: item.Address != null ? item.Address.toString() : "",
          location: {
            latitude: item.Latitute != null ? item.Latitute.toString() : "",
            longitude: item.Longitute != null ? item.Longitute.toString() : ""
          },
          terminaleType: item.TerminalType.toString(),
          terminaleCode: item.Code.toString(),
          roles: item.Roles
        }));
      }
    );
    this.$api.UserMobileService.GetPaginatedUserTerminals({
      UserId: parseInt(this.user.id),
      Search: this.search,
      Skip: Skip,
      Take: Take
    });
  }

  isValid(): boolean {
    return (this.$refs.validator as ControlValidatorGroupComponent).isValid();
  }

  getUserName(): string {
    if (this.user != null) {
      return this.user.name;
    } else {
      return " ";
    }
  }
  getEmail() {
    if (this.user == null) {
      return " ";
    }

    return this.user.email;
  }

  getRoleName() {
    if (this.user == null) {
      return " ";
    }
    var role = this.user.role;
    switch (role) {
      case 0:
        return "Не выбрано";

      case 1:
        return "RegionalManager";

      case 2:
        return "Engineer";

      case 3:
        return "Сollector";

      default:
        break;
    }
  }

  getRoles(roles: number[]) {
    if (roles == null) return "Роль не задана";
    let allChangedRoles = "";
    for (let i = 0; i < roles.length; i++) {
      switch (roles[i]) {
        case 1:
          allChangedRoles += "RegionalManager ";
          break;
        case 2:
          allChangedRoles += "Engineer ";
          break;
        case 3:
          allChangedRoles += "Сollector ";
          break;
        default:
          break;
      }
    }
    return allChangedRoles;
  }

  getTerminaleName(terminaleType: string) {
    switch (terminaleType) {
      case "0":
        return "MINI";
      case "1":
        return "MAXI";
      case "2":
        return "WEB";
      case "3":
        return "TABLETANDROID";
      default:
        break;
    }
  }

  onPaginationChanged(request: { Page: number; CountOnPage: number }) {
    this.currentPage = request.Page;
    this.getItems({
      Skip: (request.Page - 1) * request.CountOnPage,
      Take: request.CountOnPage
    });
  }

  onChangeDevice(items: ListViewItem<DeviceModel>[]) {
    //обновить роли если не определены ьл вывести все
    const deviceRoles =
      items[0].Value.roles == null ? [] : items[0].Value.roles;

    this.roles = [];
    if (deviceRoles.length == 0) {
      this.userRoles.forEach(element => {
        element.Selected = false;
      });
    } else {
      this.userRoles.forEach(element => {
        element.Selected = deviceRoles.includes(element.Value.id);
      });
    }

    this.roles = this.userRoles;
  }

  closeModalWindow() {
    this.modalWindowShow = false;
    this.userId = null;
  }
  onOpenWindowConnectDeviceToUser(userId: string, userName: string) {
    this.roles = [];
    this.userId = userId;
    this.userName = userName;
    this.getTerminale(this.user.id, "");
    this.modalWindowShow = true;
  }

  onConnectDeviceToUser() {
    if (this.devices.filter(el => el.Selected == true).length > 0) {
      const rol = this.roles.filter(el => el.Selected).map(el => el.Value.id);
      this.connectTerminale(
        this.userId.toString(),
        this.devices.filter(el => el.Selected == true)[0].Value.id,
        rol
      );
      this.closeModalWindow();
    } else {
      this.$dialog.alert("Выберите код устройства!");
    }
  }

  changeAutocomlite(serchTermit: string) {
    this.getTerminale(this.userId.toString(), serchTermit);
  }

  getRolesDD() {
    this.userRoles = [];
    this.userRoles.push(
      new ListViewItem(new DefaultModel(1, "RegionalManager"), false, false)
    );
    this.userRoles.push(
      new ListViewItem(new DefaultModel(2, "Engineer"), false, false)
    );
    this.userRoles.push(
      new ListViewItem(new DefaultModel(3, "Сollector"), false, false)
    );
  }

  /*
    проверяем терминал на существование
  */
  getTerminale(terminaleCode: string, search: string): Boolean {
    this.$api.UserMobileService.GetTerminalsForAddingEvent.once(response => {
      if (!response.IsSuccess) {
        return false;
      }
      this.devices = [];
      response.Value.forEach(element => {
        this.devices.push(
          new ListViewItem(
            new DeviceModel(
              element.Id,
              element.Code.toString(),
              element.OccupiedRoles
            ),
            false,
            false
          )
        );
      });
    });
    this.$api.UserMobileService.GetTerminalsForAdding({
      Take: 30,
      UserId: parseInt(this.user.id),
      Search: search
    });
    return true;
  }

  /*
    подключаем терминал
  */
  connectTerminale(userId: string, terminaleCode: string, rolles: number[]) {
    if (rolles == null) rolles = [];

    this.$api.UserMobileService.AddTerminalToUserEvent.once(response => {
      if (!response.IsSuccess) {
        this.$dialog.alert("Проверьте код устройства!");
        return;
      }
      this.$dialog.success("Устройство успешно добавлено!");
      this.devices = [];
      this.getTerminale(this.user.id, "");
      this.getItems({ Take: this.pageSize, Skip: this.currentPage });
    });
    this.$api.UserMobileService.AddTerminalToUser({
      UserId: parseInt(userId),
      TerminalId: parseInt(terminaleCode),
      Roles: rolles
    });
  }

  /**
   * Сортировка таблицы по имени полю и направлению(0,1)
   */
  onSort(sortName: string, sortType: string) {
    // console.log("sortName",sortName," sortType:",sortType)
    switch (sortName) {
      case "id":
        if (sortType == "1") {
          this.innerItems.sort(function(a, b) {
            return a.id > b.id ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.id < b.id ? 1 : -1;
          });
          break;
        }
      case "name":
        if (sortType == "1") {
          this.innerItems.sort(function(a, b) {
            return a.name > b.name ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.name < b.name ? 1 : -1;
          });
          break;
        }
      case "address":
        if (sortType == "1") {
          this.innerItems.sort(function(a, b) {
            return a.address > b.address ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.address < b.address ? 1 : -1;
          });
          break;
        }
      case "terminaleType":
        if (sortType == "1") {
          this.innerItems.sort(function(a, b) {
            return a.terminaleType >= b.terminaleType ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.terminaleType <= b.terminaleType ? 1 : -1;
          });
          break;
        }
      case "terminaleCode":
        if (sortType == "1") {
          this.innerItems.sort(function(a, b) {
            return a.terminaleCode > b.terminaleCode ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.terminaleCode < b.terminaleCode ? 1 : -1;
          });
          break;
        }
      case "location":
        if (sortType == "1") {
          this.innerItems.sort(function(a, b) {
            return a.location.latitude > b.location.latitude ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.location.latitude < b.location.latitude ? 1 : -1;
          });
          break;
        }
      default:
        break;
    }
  }

  onDeleteItem(el: ListViewItem<DeviceModel>) {
    this.roles.find(item => item.Value.id == el.Value.id).Selected = false;
    console.log(this.roles);
  }

  async onDisconnectDeviceFromUser(deviceId: string, deviceCode: string) {
    var res = await this.$dialog
      .confirm(
        this.$locale.getTranslate("areYouSureYouWantToDisconnectTheDevice") +
          " (" +
          deviceCode +
          ")"
      )
      .then((res: boolean) => {
        if (res) {
          this.$api.UserMobileService.RemoveTerminalFromUserEvent.once(
            response => {
              if (!response.IsSuccess) {
                return;
              }
              this.getItems({ Take: this.pageSize, Skip: this.currentPage });
            }
          );
          this.$api.UserMobileService.RemoveTerminalFromUser({
            UserId: parseInt(this.$route.params.userId),
            TerminalId: parseInt(deviceId)
          });
        }
        // if (res == false) {
        // }
      });
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/pages/page-mobile-users-devices.vue